import classNames from "classnames";
import LoadingIndicator from "src/components/loadingindicator/LoadingIndicator";
import styles from "./SuspenseFallback.module.css";

type SuspenseFallbackProps = {
    className?: string;
    text?: string;
    fullPage?: boolean;
};

export default function SuspenseFallback({ className, text, fullPage = false }: SuspenseFallbackProps) {
    return (
        <div
            className={classNames(styles.suspenseFallback, className, {
                [styles.fullPage]: fullPage,
            })}
        >
            <LoadingIndicator position="InlineCenter" />
            {text && <p className={styles.waitText}>{text}</p>}
        </div>
    );
}
